import { useState } from 'react';

function Cookies({ onAccept }) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="cookies" role="dialog" aria-live="polite">
      <div className="cookies-container">
        <div className="cookies-copy">
          <h4>Cookies & Privacy</h4>
          <p>
            We use cookies to keep your shopping cart intact, to remember your region,
            and to understand how the site is used so we can improve the studio experience.
          </p>
          {showDetails && (
            <div className="cookies-details">
              <p className="text-sm">
                Essential cookies let the site run (cart, checkout, localisation). Optional analytics cookies
                help us learn what artworks resonate most. We never sell your data and store everything securely.
              </p>
            </div>
          )}
        </div>
        <div className="cookies-actions">
          <button
            type="button"
            className="btn btn-outline"
            onClick={() => setShowDetails((prev) => !prev)}
          >
            {showDetails ? 'Hide details' : 'Learn more'}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onAccept}
          >
            Accept & continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cookies;
